/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Nog_Een_LesInputs */

const nl_planning_rooster_nog_een_les = /** @type {(inputs: Planning_Rooster_Nog_Een_LesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog een les in dit lesuur`)
};

/**

* @param {Planning_Rooster_Nog_Een_LesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_nog_een_les = /** @type {((inputs?: Planning_Rooster_Nog_Een_LesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Nog_Een_LesInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_nog_een_les(inputs)
});
export { planning_rooster_nog_een_les as "planning.rooster.nog_een_les" }